import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

export interface VpcDataPoint {
	timestamp: number;
	value: number;
}

@Component({
	selector: 'app-vpc-charts',
	templateUrl: './vpc-charts.component.html',
})
export class VpcChartsComponent implements OnChanges {
	@Input() data: VpcDataPoint[] | null = null;
	@Input() titleKey: string = '';
	@Input() seriesLabelKey: string = '';
	@Input() tooltipKey: string = '';
	@Input() haveZoom: boolean = false;
	@Input() valueMappings: { [key: number]: string } | null = null;
	@Input() vAxisTicks: any[] | null = null;
	@Input() vAxisTitle: string = '';
	@Input() hAxisTitle: string = '';
	@Input() dateFormat: string = '';

	chartData: any[] | null = null;

	chartConfig: any = {
		formatterType: 'DateFormat',
		formatter: { pattern: 'MM/dd/yyyy HH:mm:ss' },
		columnNames: [],
		config: {
			orientation: 'horizontal',
			vAxis: {
				title: this.translate.instant('event.vpc'),
				format: '#,###.00',
			},
			hAxis: {
				title: this.translate.instant('g.time'),
				format: 'MM/dd/yyyy HH:mm:ss',
			},
			chartArea: {
				bottom: 170,
			},
			explorer: {
				axis: 'horizontal',
				keepInBounds: true,
				maxZoomIn: 0.1,
			},
			series: {
				0: {
					visibleInLegend: true,
					color: '#4285F4',
					lineWidth: 2,
				},
			},
		},
	};

	constructor(private translate: TranslateService) {}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.data || changes.titleKey || changes.seriesLabelKey || changes.valueMappings)
			this.buildChart();

		if (changes.vAxisTitle)
			this.chartConfig.config.vAxis.title = changes.vAxisTitle.currentValue;

		if (changes.hAxisTitle)
			this.chartConfig.config.hAxis.title = changes.hAxisTitle.currentValue;

		if (changes.dateFormat) {
			this.chartConfig.config.hAxis.format = changes.dateFormat.currentValue;
			this.chartConfig.formatter.pattern = changes.dateFormat.currentValue;
		}
	}

	private buildChart() {
		if (!this.data?.length) {
			this.chartData = null;
			return;
		}

		const label = this.seriesLabelKey ? this.translate.instant(this.seriesLabelKey) : '';
		this.chartConfig.columnNames = ['Date', label];
		this.chartConfig.config.series[0].labelInLegend = label;

		if (this.vAxisTicks)
			this.chartConfig.config.vAxis.ticks = this.vAxisTicks;

		this.chartData = this.data.map(({ timestamp, value }) => {
			const viewedValue = this.valueMappings ? { v: value, f: this.valueMappings[value] } : value != null ? +value.toFixed(2) : 0;

			return [
				new Date(moment.utc(timestamp * 1000).format('YYYY-MM-DD HH:mm:ss')),
				viewedValue,
			]
		})
	}

	get chartTitle(): string {
		return this.titleKey ? this.translate.instant(this.titleKey) : '';
	}
}
